// Display adapters only: keep the existing API names, authentication and payloads.
import { getLanguage, normalizeLocale } from './language';
import i18n from '../i18n';
export function rowsOf(value) {
  if (Array.isArray(value)) return value;
  if (value && Array.isArray(value.data)) return value.data;
  if (value && Array.isArray(value.list)) return value.list;
  return [];
}

export function assertResponse(response) {
  if (!response || response instanceof Error || typeof response !== "object") {
    throw new Error(i18n.t('common.network_error'));
  }
  if (response.code !== undefined && Number(response.code) !== 200) {
    throw new Error(response.msg || i18n.t('common.load_failed_retry'));
  }
  if (response.data === undefined || response.data === null) {
    throw new Error(i18n.t('common.response_error'));
  }
  return response.data;
}

export function imageUrl(value) {
  if (typeof value !== "string") return "";
  const url = value.trim().replace(/\\/g, "/");
  const hostedLocalPath = url.match(/^(?:https?:)?\/\/[a-z\d.-]+(?::\d+)?(\/(?:lottery|user|base|video)\/.*)$/i)
    || url.match(/^[a-z\d][a-z\d.-]+\.[a-z]{2,}(?::\d+)?(\/(?:lottery|user|base|video)\/.*)$/i);
  if (hostedLocalPath) return hostedLocalPath[1].replace(/\/{2,}/g, "/");
  if (/^\/(?:lottery|user|base|video)\//i.test(url)) return url.replace(/\/{2,}/g, "/");
  if (/^(https?:\/\/|\/(?!\/))/i.test(url)) return url;
  if (/^\/\//.test(url)) return `https:${url}`;
  if (/^[a-z\d][a-z\d.-]+\.[a-z]{2,}(?::\d+)?(?:\/|$)/i.test(url)) {
    return `https://${url}`;
  }
  if (/^(img|images)\//.test(url)) return `/${url}`;
  return "";
}

export function siteLogoUrl(value) {
  if (typeof value !== 'string') return '';
  const url = value.trim().replace(/\\/g, '/');
  // Uploaded logos can live on a different host from the frontend.
  if (/^(https?:\/\/|\/\/)[^/\s]+(?:\/|$)/i.test(url)) return url;
  if (/^\/(?!\/)/.test(url)) return url;
  if (/^(base|img|images)\//i.test(url)) return `/${url}`;
  if (/^[a-z\d][a-z\d.-]+\.[a-z]{2,}(?::\d+)?(?:\/|$)/i.test(url)) return `https://${url}`;
  return '';
}

export function localizedName(value, locale = getLanguage()) {
  const parts = String(value || "").split(",");
  // API data format: index 0=zh, 1=en, 2=ja, 3=kr
  // fr and es fall back to English (index 1)
  const index = { en: 1, ja: 2, kr: 3, fr: 1, es: 1 }[normalizeLocale(locale)];
  return parts[index] || parts[1] || parts[0];
}

export function displayNumber(value) {
  if (value === undefined || value === null || value === "") return "—";
  const number = Number(value);
  return Number.isFinite(number) ? number.toLocaleString("zh-TW", { maximumFractionDigits: 2 }) : "—";
}
